@if (card(); as c) {
<div class="modal-overlay" (overlayDismiss)="dismiss()">
  <div class="modal-shell modal-shell--narrow invite-shell">
    <div class="modal-header">
      <div class="modal-marquee">
        <div class="modal-marquee-track">
          <span class="modal-marquee-text">PARTY INVITE&nbsp;·&nbsp;PARTY INVITE&nbsp;·&nbsp;</span>
          <span class="modal-marquee-text">PARTY INVITE&nbsp;·&nbsp;PARTY INVITE&nbsp;·&nbsp;</span>
        </div>
      </div>
      <button class="modal-close" (click)="dismiss()" aria-label="Close">×</button>
    </div>

    <div class="modal-body">
      @if (result(); as r) {
        @if (r.accepted) {
          <div class="modal-section">
            <p class="inv-status ok">Seat claimed — waiting for the battle to start…</p>
          </div>
        } @else {
          <!-- Race loser: the first claim won in the lobby; nothing left this client on-chain. -->
          <div class="modal-section">
            <div class="modal-label bad">seat taken</div>
            <p class="losecopy">This seat was claimed first. Your SeatFill was discarded — nothing signed on-chain.</p>
          </div>
          <div class="modal-section modal-section--footer">
            <button class="modal-btn modal-btn--ghost modal-btn--block" (click)="dismiss()">Back to lobby</button>
          </div>
        }
      } @else {
        <div class="modal-section">
          <div class="inv-head">
            <span class="modal-label">open party</span>
            <span class="fine">{{ seatCountLabel() }}</span>
          </div>

          <!-- 2×2 matchup: top row opponents, bottom row your side; your seat highlighted. -->
          <div class="invmatch">
            @for (cell of matchCells(); track cell.idx) {
              <ng-container [ngTemplateOutlet]="invCell" [ngTemplateOutletContext]="{ cell: cell }" />
            }
            <span class="invvs">VS</span>
          </div>

          @if (activeTeam(); as t) {
            <div class="team-block">
              <span class="modal-label">your team</span>
              <div class="team-row">
                <span class="tl">{{ t.name }}</span>
                <div class="mons">
                  @for (m of t.monIds; track $index) {
                    <app-mon-static-sprite [monId]="toNum(m)" spriteType="micro" [displayWidth]="24" [displayHeight]="24" />
                  }
                </div>
              </div>
            </div>
          }
        </div>

        <div class="modal-section modal-section--footer inv-foot">
          <button class="modal-btn modal-btn--ghost" (click)="dismiss()">Dismiss</button>
          <button class="modal-btn modal-btn--lg modal-btn--primary" (click)="claim()">Sign &amp; Claim Seat</button>
        </div>
      }
    </div>
  </div>
</div>
}

<ng-template #invCell let-cell="cell">
  <div class="invcell" [class.sa]="cell.side === 'a'" [class.sb]="cell.side === 'b'" [class.here]="cell.idx === card()?.yourSeatIndex">
    @if (cell.idx === card()?.yourSeatIndex) {
      <div class="placeholder-av">?</div>
      <span class="icn">You</span>
    } @else if (cell.seat.kind === 'cpu') {
      <div class="cpu-av">CPU</div>
      <span class="icn">CPU</span>
    } @else if (cell.seat.filled && cell.seat.address) {
      <app-pixel-creature class="cav" [addr]="cell.seat.address" [size]="30" />
      <span class="icn" [style.color]="cell.seat.address | addressColor">{{ cell.name || 'player' }}</span>
    } @else {
      <div class="placeholder-av">?</div>
      <span class="icn muted">{{ cell.seat.kind === 'named' ? 'invited' : 'open' }}</span>
    }
  </div>
</ng-template>
